// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"205acd37","6686":"205acd37"}[chunkId] + ".chunk.css";
};